// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper_kqMw9","content":"content_lDnal"};